import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";
import {LayoutAbbreviations, useOldCabinetLogic} from "../../constants";

export default class TopCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'top_cabinet';
    this.partName = 'Top Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.top_cabinet";
    this.canBeDisabled = false;
    this.hasAdditionalParts = true;
    this.layerPriority = 1;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    return super.load_(dbFeature, new TopCabinet(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const topHandle = this.getParent().topHandle;
    if (topHandle) {
      topHandle.disabled = this.disabled;
    }
    const crownMolding = this.getParent().crownMolding;
    if (crownMolding) {
      crownMolding.disabled = this.disabled;
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    if (useOldCabinetLogic) {
      return conditions
    }
    const cabinetParent = this.getParent();
    const applianceParent = cabinetParent.layout.parts[Appliance.id];
    const hoodIsVisible = applianceParent && applianceParent.hood && applianceParent.hood.activeFeature && !applianceParent.hood.disabled;
    const microwaveIsVisible = applianceParent && applianceParent.microwave && applianceParent.microwave.activeFeature && !applianceParent.microwave.disabled;
    conditions.push({
      propName: "Hood",
      propValue: hoodIsVisible || ((cabinetParent.layout.type === 6) && microwaveIsVisible) ? "H" : "C"
    });
    if (hoodIsVisible && applianceParent.hood.activeFeature.metaData["Width"]) {
      conditions.push({
        propName: "Width",
        propValue: applianceParent.hood.activeFeature.metaData["Width"]
      });
    }
    return conditions
  }

  getActiveFeatureConditions() {
    return this.getArrayOfConditions().filter(metaObject => {
      return metaObject.propName !== "Hood" && metaObject.propName !== "Width"
    })
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const applianceParent = cabinetParent.layout.parts[Appliance.id];

      // part1 - depends on hood - H hood enabled, С - disabled
      // part1 - depends on hood "Width"
      // part2 - depends on Fridge
      // part3 - was part 6
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (useOldCabinetLogic) {
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")
            && (!applianceParent || !applianceParent.hood || applianceParent.hood.disabled || !applianceParent.hood.activeFeature)) {
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
          }
          if (cabinetParent.layout.type === 4 && feature.metaData["Part"] && feature.metaData["Part"].includes("3")
            && applianceParent && applianceParent.fridge && (applianceParent.fridge.disabled || !applianceParent.fridge.activeFeature)) {
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
          }
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("6")) { // 6 is fridge related
            if (!applianceParent || !applianceParent.fridge || applianceParent.fridge.disabled || !applianceParent.fridge.activeFeature) {
              return false
            }
            const fridgeConditions = applianceParent.fridge.getFridgeWidthAndHeightConditions();
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([...arrayOfConditions, ...fridgeConditions])
          }
        } else {
          if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
            const fridgeIsVisible = applianceParent && applianceParent.fridge && !applianceParent.fridge.disabled
              && applianceParent.fridge.activeFeature;
            const fridgeConditions = applianceParent && applianceParent.fridge
              ? applianceParent.fridge.getFridgeWidthAndHeightConditions()
              : [];
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([
              ...arrayOfConditions, {
                propName: "Fridge",
                propValue: fridgeIsVisible ? "F" : "C"
              }, ...fridgeConditions
            ])
          } else if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")) {
            if (!applianceParent || !applianceParent.oven || applianceParent.oven.disabled || !applianceParent.oven.activeFeature) {
              return false
            }
            return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
          }
        }
        return false
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

}

